
import { Sinister } from '../../../../features/typescript/sinisters/sinisterInfo';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import NoteForm from '../../../core/components/Notes/NoteForm.vue'
import { Note } from '../../../typescript/notes/notes'
import { ClaimsApi } from '../../../core/api/ClaimsApi';
import { EventBus, TypeEventBus } from '../../../../features/core/utils';
@Component({
  components: {
    NoteForm
  },
})
export default class SinisterNotes extends Vue {
  @Prop({ default: () => [] }) sinister!: Sinister
  notes: Note[] = [];

  noteText: string = ''
  noteImages: (File | string)[] = []

  isEditing = false
  editingIndex: number | null = null;

  created(){
    
  }

  fetchNotes(): Promise<Note[]> {
    return ClaimsApi.getSinisterNotes(this.sinister.id)
      .then(res => {
        this.seeNotesInMap(res.ranch_notes)
        return res.ranch_notes
      })
  }

  @Emit()
  seeNotesInMap(notes: Note[]){}

  addNote(note: Note) {
    let sinisterId:any = this.sinister.id;
    return ClaimsApi.postNote(sinisterId, note)
  }

  updateNote(note: Note) {
    return ClaimsApi.patchNote(note)
  }

  deleteNote(note: Note) {
    return ClaimsApi.deleteNote(note.id as number)
  }

  cancelEdit() {
    this.resetForm()
  }

  resetForm() {
    this.noteText = ''
    this.noteImages = []
    this.editingIndex = null
    this.isEditing = false
  }

  formatDate(date: Date) {
    return new Intl.DateTimeFormat('es-AR', {
      dateStyle: 'short',
      timeStyle: 'short'
    }).format(new Date(date))
  }
}
